import { DrinksPerDay } from "@dcc/types/drinkingDay";
import { DayOfWeek } from "@dcc/types/dayOfWeek";

export interface DrinkingDayTabEnabled {
  [index: number]: boolean;
}

const drinksEnteredOnDay = (
  drinksPerDay: Readonly<DrinksPerDay[]>,
  dayNo: number
) => {
  const day = drinksPerDay.find((d) => d.day === dayNo);
  return day ? day.amount > 0 : false;
};

const getPreviousDays = (
  drinksPerDay: Readonly<DrinksPerDay[]>,
  curr: DayOfWeek
) => drinksPerDay.filter((d) => d.day < curr);

const drinksEnteredOnPreviousDays = (
  drinksPerDay: Readonly<DrinksPerDay[]>,
  current: DayOfWeek
) =>
  getPreviousDays(drinksPerDay, current).reduce((agg, curr) => {
    return agg && drinksEnteredOnDay(drinksPerDay, curr.day);
  }, true);

const isCurrentTab = (index: number, currentTab: number) =>
  currentTab === index;

export const setTabsEnabled = (
  drinksPerDay: Readonly<DrinksPerDay[]>,
  currentTab: number
): DrinkingDayTabEnabled =>
  drinksPerDay.reduce((agg: DrinkingDayTabEnabled, current, index) => {
    agg[current.day] =
      isCurrentTab(index, currentTab) ||
      (index < 1
        ? true
        : drinksEnteredOnPreviousDays(drinksPerDay, current.day));

    return agg;
  }, {});

export const setNextDisabled = (
  drinksPerDay: Readonly<DrinksPerDay[]>,
  currentTab: number
) => drinksPerDay[currentTab].amount <= 0;

export const replaceSpacesWithDashes = (str: string) => str.replace(/ /g, "-");
